import React from 'react';
import DimmedLoader from '@amzn/GuardianWidgetCommons/lib/components/DimmedLoader';

export const NoDataIndication = (isSearching: boolean): JSX.Element => {
    return <DimmedLoader active={isSearching}>No Results</DimmedLoader>;
};
